import React, { useEffect, useState } from "react";
import { Table, Button, Input } from "antd";
import axios from "axios";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ManageNotice = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    const res = await axios.get("https://rhrmapi.up2dateinc.com/api/notices");
    setData(res.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    await axios.delete(`https://rhrmapi.up2dateinc.com/api/notices/${id}`);
    fetchData();
  };

  const columns = [
    { title: "SL No", render: (_, __, i) => i + 1 },
    { title: "Notice Type", dataIndex: "type" },
    { title: "Description", dataIndex: "description" },
    { title: "Notice Date", dataIndex: "date" },
    { title: "Notice By", dataIndex: "by" },
    {
      title: "Action",
      render: (record) => (
        <>
          <EditOutlined
            onClick={() => navigate(`/admin/update-notice/${record._id}`)}
            style={{ marginRight: 15 }}
          />
          <DeleteOutlined
            onClick={() => handleDelete(record._id)}
          />
        </>
      ),
    },
  ];

  return (
    <div>
      <Input.Search placeholder="Search..." style={{ marginBottom: 10 }} />
      <Table dataSource={data} columns={columns} rowKey="_id" />
    </div>
  );
};

export default ManageNotice;